<div class="grid-x">
    <label for="loc">Context Target</label>
    <input class="cell small-12" id="loc" type="text" placeholder="Context Target" [(ngModel)]="data.configuration.contextTarget" />
    <rules-editor class="cell small-12" [rule]="data.configuration.rule" (updateRule)="data.configuration.rule = $event" placeholder="Organization Id Rule" type="Organization Id"></rules-editor>
</div>